package com.banyan.flightviewer.state

/** Identifies an ATC audio stream currently playing or selected for playback. */
data class AtcStreamInfo(
    val airportCode: String,
    val feedName: String,
    val url: String,
    /**
     * Optional section label. Feeds sharing the same non-blank [category]
     * are rendered as a titled group above the regular feeds in the
     * airport panel. Blank = regular feed. Example: "Sun 'n Fun Fly-In".
     */
    val category: String = "",
)

/** Runtime status of the currently active ATC stream. */
enum class AtcStreamStatus {
    LOADING,  // Media is being prepared (connecting, buffering)
    PLAYING,  // Media is actively playing
    STALLED,  // Media is buffering after initial playback started
    ERROR,    // Playback failed -- error message available via statusMessage
}

